// UI chrome strings. EN + NL are complete; BG/UK fall back to EN where missing.
const en = {
  eyebrow: "RBL × MILLENNIUM · PARTICIPANT HUB",
  hubTitle: "Basic Leadership Training",
  hubOrg: "Millennium Print Group",
  hubIntro:
    "Six sessions. One workbook. Everything you need to make Monday morning different — from setting expectations to feedback that lands.",
  sixSessions: "The 6 Sessions",
  openSession: "Open session →",
  libraryTitle: "Visual Library",
  libraryDesc:
    "All infographics from the 6 sessions in one place — view & download as a printable booklet.",
  participantApp: "PARTICIPANT APP",
  haveAccount: "Have an account? Open your personal training app",
  participantAppDesc:
    "Sign in to save your reflections, worksheets and quiz answers safely on the server — across devices. The hub stays public; this opens your private app environment.",
  openParticipantApp: "→ Open the participant app",
  journeyTitle: "My Training Journey",
  journeyDesc:
    "Download a personalised PDF with all 6 sessions, theory, infographics and your own worksheet answers. Type your name and click below.",
  journeyButton: "↓ Download My Training Journey PDF",
  journeyHint:
    "The PDF includes your worksheet answers from this browser. Fill them in on each session page before downloading.",
  footer: "RBL Training × Millennium Print Group — Teamleads Leadership Programme 2026.",
  adminLogin: "Trainer / admin login →",
  allSessions: "← All sessions",
  session: "SESSION",
  downloadSession: "↓ Download this session (PDF)",
  backToDashboard: "Back to dashboard ↩",
  prevSession: "← Session",
  nextSession: "Session",
  // auth
  login: "Log in",
  email: "Email",
  password: "Password",
  signIn: "Sign in",
  forgotPassword: "Forgot password?",
  backToHub: "← Back to the hub",
  loginSubtitle: "Sign in to your personal training app",
  forgotTitle: "Forgot password",
  forgotDesc: "Enter your email and we'll send you a reset link.",
  sendResetLink: "Send reset link",
  resetSent: "If that email exists, a reset link is on its way.",
  resetTitle: "Choose a new password",
  newPassword: "New password",
  confirmPassword: "Confirm password",
  savePassword: "Save password",
  passwordSaved: "Your password has been updated. You can now sign in.",
  // worksheet / quiz
  savedLocally: "Your answers are saved in this browser and included in your Training Journey PDF.",
  quickCheckHint: "Tap the answer you think is right — you'll see feedback instantly.",
  correct: "Correct!",
  incorrect: "Not quite — try again.",
  commitmentName: "Your name (optional)",
  commitmentLabel: "My commitment for Monday morning",
  lockCommitment: "Lock in my commitment →",
  commitmentSaved: "Your commitment is locked in. See you Monday! 🚀",
  welcomeGreeting: "Welcome",
  welcomeSubtitle: "Set your password to open your personal training app.",
  welcomeInvalid: "This link is invalid or has expired.",
  passwordsNoMatch: "Passwords do not match.",
};

const nl = {
  eyebrow: "RBL × MILLENNIUM · DEELNEMERS HUB",
  hubTitle: "Basis Leiderschapstraining",
  hubOrg: "Millennium Print Group",
  hubIntro:
    "Zes sessies. Één werkboek. Alles wat je nodig hebt om maandagochtend anders te maken — van verwachtingen stellen tot feedback die landt.",
  sixSessions: "De 6 Sessies",
  openSession: "Open sessie →",
  libraryTitle: "Visuele Bibliotheek",
  libraryDesc:
    "Alle infographics uit de 6 sessies op één plek — bekijk & download als printbaar boekje.",
  participantApp: "DEELNEMERS-APP",
  haveAccount: "Heb je een account? Open je persoonlijke trainingsapp",
  participantAppDesc:
    "Log in om je reflecties, werkbladen en quizantwoorden veilig op de server op te slaan — op al je apparaten. De hub blijft openbaar; dit opent je persoonlijke omgeving.",
  openParticipantApp: "→ Open de deelnemers-app",
  journeyTitle: "Mijn Trainingsreis",
  journeyDesc:
    "Download een persoonlijke PDF met alle 6 sessies, theorie, infographics en je eigen werkbladantwoorden. Typ je naam en klik hieronder.",
  journeyButton: "↓ Download Mijn Trainingsreis PDF",
  journeyHint:
    "De PDF bevat je werkbladantwoorden uit deze browser. Vul ze in op elke sessiepagina voordat je downloadt.",
  footer: "RBL Training × Millennium Print Group — Teamleads Leiderschapsprogramma 2026.",
  adminLogin: "Trainer / admin login →",
  allSessions: "← Alle sessies",
  session: "SESSIE",
  downloadSession: "↓ Download deze sessie (PDF)",
  backToDashboard: "Terug naar dashboard ↩",
  prevSession: "← Sessie",
  nextSession: "Sessie",
  login: "Inloggen",
  email: "E-mail",
  password: "Wachtwoord",
  signIn: "Inloggen",
  forgotPassword: "Wachtwoord vergeten?",
  backToHub: "← Terug naar de hub",
  loginSubtitle: "Log in op je persoonlijke trainingsapp",
  forgotTitle: "Wachtwoord vergeten",
  forgotDesc: "Vul je e-mail in en we sturen je een resetlink.",
  sendResetLink: "Stuur resetlink",
  resetSent: "Als dat e-mailadres bestaat, is er een resetlink onderweg.",
  resetTitle: "Kies een nieuw wachtwoord",
  newPassword: "Nieuw wachtwoord",
  confirmPassword: "Bevestig wachtwoord",
  savePassword: "Wachtwoord opslaan",
  passwordSaved: "Je wachtwoord is bijgewerkt. Je kunt nu inloggen.",
  savedLocally:
    "Je antwoorden worden opgeslagen in deze browser en opgenomen in je Trainingsreis-PDF.",
  quickCheckHint: "Tik op het antwoord dat je juist vindt — je ziet meteen feedback.",
  correct: "Juist!",
  incorrect: "Net niet — probeer opnieuw.",
  commitmentName: "Je naam (optioneel)",
  commitmentLabel: "Mijn commitment voor maandagochtend",
  lockCommitment: "Leg mijn commitment vast →",
  commitmentSaved: "Je commitment staat vast. Tot maandag! 🚀",
  welcomeGreeting: "Welkom",
  welcomeSubtitle: "Stel je wachtwoord in om je persoonlijke trainingsapp te openen.",
  welcomeInvalid: "Deze link is ongeldig of verlopen.",
  passwordsNoMatch: "Wachtwoorden komen niet overeen.",
};

// BG / UK: minimal overrides; everything else falls back to EN.
const bg = {
  eyebrow: "RBL × MILLENNIUM · ПОРТАЛ ЗА УЧАСТНИЦИ",
  hubTitle: "Базово обучение по лидерство",
  sixSessions: "6-те сесии",
  openSession: "Отвори сесия →",
  signIn: "Вход",
  login: "Вход",
  loginSubtitle: "Влезте в личното си приложение за обучение",
  email: "Имейл",
  password: "Парола",
  forgotPassword: "Забравена парола?",
  backToHub: "← Обратно към портала",
  forgotTitle: "Забравена парола",
  forgotDesc: "Въведете имейла си и ще ви изпратим връзка за нулиране.",
  sendResetLink: "Изпрати връзка за нулиране",
  resetSent: "Ако този имейл съществува, връзка за нулиране е на път.",
  resetTitle: "Изберете нова парола",
  newPassword: "Нова парола",
  confirmPassword: "Потвърдете паролата",
  savePassword: "Запази паролата",
  passwordSaved: "Паролата ви е обновена. Вече можете да влезете.",
  welcomeGreeting: "Добре дошли",
  welcomeSubtitle: "Задайте паролата си, за да отворите личното си приложение за обучение.",
  welcomeInvalid: "Тази връзка е невалидна или е изтекла.",
  passwordsNoMatch: "Паролите не съвпадат.",
};
const uk = {
  eyebrow: "RBL × MILLENNIUM · ПОРТАЛ УЧАСНИКА",
  hubTitle: "Базове навчання лідерству",
  sixSessions: "6 сесій",
  openSession: "Відкрити сесію →",
  signIn: "Увійти",
  login: "Увійти",
  loginSubtitle: "Увійдіть до свого персонального застосунку для навчання",
  email: "Електронна пошта",
  password: "Пароль",
  forgotPassword: "Забули пароль?",
  backToHub: "← Назад до порталу",
  forgotTitle: "Забули пароль",
  forgotDesc: "Введіть свою електронну пошту, і ми надішлемо посилання для скидання.",
  sendResetLink: "Надіслати посилання",
  resetSent: "Якщо така пошта існує, посилання для скидання вже надіслано.",
  resetTitle: "Оберіть новий пароль",
  newPassword: "Новий пароль",
  confirmPassword: "Підтвердьте пароль",
  savePassword: "Зберегти пароль",
  passwordSaved: "Ваш пароль оновлено. Тепер ви можете увійти.",
  welcomeGreeting: "Вітаємо",
  welcomeSubtitle: "Встановіть пароль, щоб відкрити свій персональний застосунок для навчання.",
  welcomeInvalid: "Це посилання недійсне або термін його дії минув.",
  passwordsNoMatch: "Паролі не збігаються.",
};

const DICT = { en, nl, bg, uk };

export function useUi(lang) {
  const base = DICT[lang] || en;
  return (key) => base[key] ?? en[key] ?? key;
}

export default DICT;
